/* MPS "Estimate delivery" calculator (cart drawer + cart page).
   Uses the cart's real contents via /cart/prepare_shipping_rates.json + /cart/async_shipping_rates.json. */
(function () {
  if (customElements.get('mps-shipping-estimator')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CONTACT_URL = ROOT.replace(/\/?$/, '/') + 'pages/contact-us';
  var WHATSAPP_URL = 'https://wa.me/447483404279';
  var STORE_KEY = 'mps_ship_estimate';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return esc(amount);
    if (n === 0) return 'FREE';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
      }).format(n);
    } catch (e) {
      return n.toFixed(2);
    }
  }

  function sleep(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  class MpsShippingEstimator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.country = this.querySelector('.mps-ship__country');
      this.province = this.querySelector('.mps-ship__province');
      this.provinceWrap = this.querySelector('.mps-ship__field--province');
      this.zip = this.querySelector('.mps-ship__zip');
      this.button = this.querySelector('.mps-ship__button');
      this.result = this.querySelector('.mps-ship__result');
      if (!this.country || !this.button) return;

      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { saved = null; }

      this.selectCountry((saved && saved.country) || this.dataset.defaultCountry || 'United Kingdom');
      this.updateProvinces(saved && saved.province);
      if (saved && saved.zip && this.zip && !this.zip.value) this.zip.value = saved.zip;

      this.country.addEventListener('change', () => this.updateProvinces());
      this.button.addEventListener('click', () => this.calculate());

      // Inside the scrollable cart drawer list (mobile): keep the opened panel in view
      // instead of letting it push content around off-screen.
      this.details = this.querySelector('.mps-ship__details');
      if (this.details) {
        this.details.addEventListener('toggle', () => {
          if (this.details.open) this.reveal(this, 'start');
        });
      }
      if (this.zip) {
        this.zip.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); this.calculate(); }
        });
      }
    }

    selectCountry(name) {
      var opts = this.country.options;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].value === name || opts[i].text === name) { this.country.selectedIndex = i; return; }
      }
    }

    updateProvinces(selected) {
      var opt = this.country.options[this.country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      if (!this.province || !this.provinceWrap) return;
      this.province.innerHTML = '';
      if (!list.length) { this.provinceWrap.hidden = true; return; }
      list.forEach((p) => {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1] || p[0];
        if (selected && (selected === p[0] || selected === p[1])) o.selected = true;
        this.province.appendChild(o);
      });
      this.provinceWrap.hidden = false;
    }

    show(kind, html) {
      this.result.className = 'mps-ship__result mps-ship__result--' + kind;
      this.result.innerHTML = html;
      this.result.hidden = false;
      this.reveal(this.result, 'nearest');
    }

    reveal(el, block) {
      // Only scroll when we sit in the drawer's scrolling list, never from the sticky footer.
      if (!el || !this.closest('.drawer__content')) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      requestAnimationFrame(function () {
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: block || 'nearest' });
      });
    }

    fallbackHtml(lead) {
      return (
        '<strong>' + esc(lead) + '</strong><br>' +
        'We can still get it to you, <a href="' + CONTACT_URL + '">contact us</a> or ' +
        '<a href="' + WHATSAPP_URL + '" target="_blank" rel="noopener">WhatsApp us</a> for a delivery quote.'
      );
    }

    async calculate() {
      var country = this.country.value;
      var province = this.provinceWrap && !this.provinceWrap.hidden && this.province ? this.province.value : '';
      var zip = this.zip ? this.zip.value.trim() : '';
      if (!country) return;

      try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ country: country, province: province, zip: zip })); } catch (e) {}

      var params = new URLSearchParams();
      params.set('shipping_address[country]', country);
      params.set('shipping_address[province]', province);
      params.set('shipping_address[zip]', zip);
      var base = ROOT.replace(/\/?$/, '/') + 'cart/';

      this.button.disabled = true;
      this.button.textContent = 'Calculating…';
      this.show('ok', 'Checking delivery options…');

      try {
        var prep = await fetch(base + 'prepare_shipping_rates.json?' + params.toString(), { method: 'POST' });
        if (prep.status === 422 || prep.status === 400) {
          var err = await prep.json().catch(function () { return {}; });
          this.showError(err);
          return;
        }

        var data = null;
        for (var i = 0; i < 12; i++) {
          var res = await fetch(base + 'async_shipping_rates.json?' + params.toString());
          if (res.status === 200) {
            data = await res.json();
            if (data && data.shipping_rates) break;
          } else if (res.status === 422 || res.status === 400) {
            this.showError(await res.json().catch(function () { return {}; }));
            return;
          }
          await sleep(500);
        }

        var rates = (data && data.shipping_rates) || [];
        if (!rates.length) {
          this.show('empty', this.fallbackHtml('No standard delivery rate for this basket to ' + country + '.'));
          return;
        }

        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var items = rates.map(function (r) {
          return '<li><span>' + esc(r.presentment_name || r.name) + '</span><strong>' + money(r.price, r.currency) + '</strong></li>';
        }).join('');
        this.show(
          'ok',
          '<strong>' + (rates.length === 1 ? '1 delivery option' : rates.length + ' delivery options') +
            ' to ' + esc(country) + (zip ? ' ' + esc(zip.toUpperCase()) : '') + ':</strong><ul>' + items + '</ul>'
        );
      } catch (e) {
        this.show('error', this.fallbackHtml('Sorry, we could not calculate delivery right now.'));
      } finally {
        this.button.disabled = false;
        this.button.textContent = 'Calculate';
      }
    }

    showError(err) {
      var msgs = [];
      if (err && typeof err === 'object') {
        Object.keys(err).forEach(function (k) {
          var v = err[k];
          (Array.isArray(v) ? v : [v]).forEach(function (m) {
            var field = k === 'zip' ? 'Postcode' : k === 'country' ? 'Country' : k === 'province' ? 'Region' : '';
            msgs.push((field ? field + ' ' : '') + m);
          });
        });
      }
      var noRates = msgs.join(' ').toLowerCase().indexOf('not supported') !== -1 || msgs.join(' ').toLowerCase().indexOf('do not ship') !== -1;
      if (noRates || !msgs.length) {
        this.show('empty', this.fallbackHtml('No standard delivery rate for this basket to this address.'));
      } else {
        this.show('error', '<strong>Please check the address:</strong><br>' + esc(msgs.join('. ')));
      }
      this.button.disabled = false;
      this.button.textContent = 'Calculate';
    }
  }

  customElements.define('mps-shipping-estimator', MpsShippingEstimator);

  // Footer "Estimate delivery" link (mobile): open the estimator in the list and scroll to it.
  document.addEventListener('click', function (e) {
    var jump = e.target.closest && e.target.closest('[data-mps-ship-jump]');
    if (!jump) return;
    var drawer = jump.closest('cart-drawer') || document;
    var est = drawer.querySelector('.mps-drawer-extras mps-shipping-estimator');
    if (!est) return;
    e.preventDefault();
    var details = est.querySelector('.mps-ship__details');
    if (details && !details.open) {
      details.open = true; // toggle handler scrolls it into view
    } else {
      est.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
